import { render, staticRenderFns } from "./TabletAdmin.vue?vue&type=template&id=b9f6ae8a&scoped=true"
import script from "./TabletAdmin.vue?vue&type=script&lang=js"
export * from "./TabletAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f6ae8a",
  null
  
)

export default component.exports